import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// ZCS Components
import { AzzurroTable, KeyValueBlockModule, CopyToClipboardModule, FormatHexDataModule } from 'ngx-zcs-components';

// Components
import { DeviceSearchComponent } from './device-search/device-search.component';
import { SessionListComponent } from './session-list/session-list.component';
import { SessionDetailsComponent } from './session-details/session-details.component';
import { SgpCommandViewerComponent } from './sgp-command-viewer/sgp-command-viewer.component';

@NgModule({
  declarations: [
    DeviceSearchComponent,
    SessionListComponent,
    SessionDetailsComponent,
    SgpCommandViewerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Angular Material
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressSpinnerModule,

    // ZCS Components
    AzzurroTable,
    KeyValueBlockModule,
    CopyToClipboardModule,
    FormatHexDataModule
  ],
  exports: [
    DeviceSearchComponent,
    SessionListComponent,
    SessionDetailsComponent,
    SgpCommandViewerComponent
  ]
})
export class ComponentsModule { }